import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { prefillState } from "@/utils/prefillState";
import { getSearchFromState } from "@/utils/getSearchFromState";
import { getStateFromSearch } from "@/utils/getStateFromSearch";
import { getValidFiltersState } from "@/utils/getValidFiltersState";
import { useOptionsStoreActions } from "@/hooks/store/useOptionsStore";
import { SELLERS, INVENTORY, ORDER_OR_GROUP_ID } from "./ProductionTableSearch.consts";

export const useProductionSearch = () => {
  const { loadSellersOptions, loadInventoriesOptions, sellersOptions, inventoriesOptions } =
    useOptionsStoreActions();
  const route = useRoute();
  const router = useRouter();

  const filters = [
    { key: SELLERS, init: "", type: "string" },
    { key: INVENTORY, init: "", type: "string" },
    { key: ORDER_OR_GROUP_ID, init: "", type: "string" },
  ];

  const formData = ref(prefillState(filters));

  onMounted(() => {
    formData.value = { ...formData.value, ...getStateFromSearch(route.query, filters) };
    loadSellersOptions();
    loadInventoriesOptions();
  });

  const handleSearch = () => {
    const values = getValidFiltersState({ ...formData.value });
    const nextPath = getSearchFromState(route.query, filters, values);
    router.push({ path: route.path, query: nextPath });
  };

  return { formData, sellersOptions, inventoriesOptions, handleSearch };
};
